export { default } from "./ApprovedVendorsPage";
export { ApprovedVendorsPage } from "./ApprovedVendorsPage";
export type { AdminVendor } from "types/vendor";
